import { Tool } from 'app/types/tool';
import MaintenanceForm from './Form';
import { useCreateMaintenanceMutation, useGetMaintenanceQuery } from 'app/services/tools';

const CreateMaintenance = ({ tool }: { tool: Tool }) => {
  const [ create, meta ] = useCreateMaintenanceMutation();
  const { data: maintenanceHistory } = useGetMaintenanceQuery(tool.Id);

  const previousFilterSerialNumber = maintenanceHistory?.slice()
    .sort((a, b) => new Date(b.ExecutedAt).getTime() - new Date(a.ExecutedAt).getTime())[0]?.FilterSerialNumber;

  const onSubmit = async (values: any) => {
    await create({ toolId: tool.Id, ...values }).unwrap();
  };

  return <MaintenanceForm
    handleSubmit={onSubmit}
    meta={meta}
    previousFilterSerialNumber={previousFilterSerialNumber}
  />;
};

export default CreateMaintenance;